/* Enhance semantic Ghost content without reparsing or replacing protected article HTML. */
(function () {
    const labels = document.getElementById('fw-i18n').dataset;
    const content = document.querySelector('.fw-content');
    if (!content) return;

    const types = ['note', 'tip', 'important', 'warning', 'caution'];
    const iconPaths = {
        note: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v1"/>',
        tip: '<path d="M8 15c0-2-3-3-3-7a7 7 0 0 1 14 0c0 4-3 5-3 7M9 18h6m-5 3h4M8 15h8"/>',
        important: '<path d="M3 3h18v14h-9l-6 4v-4H3ZM12 6v5m0 2v1"/>',
        warning: '<path d="m12 3 10 18H2ZM12 9v5m0 2v1"/>',
        caution: '<path d="M8 2h8l6 6v8l-6 6H8l-6-6V8ZM12 6v8m0 3v1"/>'
    };

    // Only explicit admonition markup or GitHub's [!TYPE] marker becomes an alert.
    content.querySelectorAll('blockquote').forEach(function (quote) {
        let type = quote.dataset.fwAdmonition;
        types.forEach(function (candidate) { if (quote.classList.contains('bdm-' + candidate)) type = candidate; });
        const paragraph = quote.querySelector(':scope > p');
        const intro = paragraph || quote;
        const marker = intro.firstChild && intro.firstChild.nodeType === Node.TEXT_NODE ? intro.firstChild.textContent.match(/^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\](?:\s|$)/) : null;
        if (marker) {
            type = marker[1].toLowerCase();
            intro.firstChild.textContent = intro.firstChild.textContent.slice(marker[0].length);
            if (intro.firstChild.nextSibling && intro.firstChild.nextSibling.nodeName === 'BR') intro.firstChild.nextSibling.remove();
            if (paragraph && !paragraph.textContent.trim() && !paragraph.querySelector('img,video,iframe')) paragraph.remove();
            // Ghost may serialize a quote as direct text with line breaks instead of nested paragraphs.
            if (!paragraph) {
                const body = document.createElement('p');
                body.append(...Array.from(quote.childNodes));
                quote.appendChild(body);
            }
        }
        if (!types.includes(type)) return;
        quote.classList.add('fw-admonition');
        quote.dataset.type = type;
        let title = quote.querySelector(':scope > .bdm-title, :scope > .fw-admonition-title');
        if (!title) {
            title = document.createElement('span');
            title.textContent = type.toUpperCase();
            quote.prepend(title);
        }
        title.classList.add('fw-admonition-title');
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('stroke-width', '1.8');
        icon.setAttribute('stroke-linecap', 'round');
        icon.setAttribute('stroke-linejoin', 'round');
        icon.setAttribute('aria-hidden', 'true');
        icon.classList.add('fw-admonition-icon');
        // The icon paths above are fixed theme assets, never article-supplied HTML.
        icon.innerHTML = iconPaths[type];
        title.prepend(icon);
    });

    // Keep IDs and expose unobtrusive permalink controls without a permanently visible hash.
    content.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading, index) {
        if (heading.closest('.kg-card,.gh-post-upgrade-cta,[hidden]')) return;
        if (!heading.id) {
            const base = 'fw-heading-' + (index + 1);
            let id = base;
            let suffix = 0;
            while (document.getElementById(id)) id = base + '-' + (++suffix);
            heading.id = id;
        }
        let anchor = Array.from(heading.querySelectorAll('a')).find(function (link) { return link.getAttribute('href') === '#' + heading.id && link.textContent.trim() === '#'; });
        if (!anchor) {
            anchor = document.createElement('a');
            anchor.href = '#' + encodeURIComponent(heading.id);
            anchor.textContent = '#';
            heading.appendChild(anchor);
        }
        anchor.classList.add('fw-heading-anchor');
        anchor.setAttribute('aria-label', labels.section);
    });

    // Add line gutters and copying while leaving the original code text and newlines untouched.
    content.querySelectorAll('pre > code').forEach(function (code) {
        const pre = code.parentElement;
        if (pre.closest('.fw-code,.expressive-code,.gh-post-upgrade-cta,[hidden]')) return;
        const text = code.textContent;
        const wrapper = document.createElement('div');
        wrapper.className = 'fw-code';
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        pre.tabIndex = 0;
        pre.setAttribute('aria-label', labels.codeBlock);
        const gutter = document.createElement('span');
        gutter.className = 'fw-code-gutter';
        gutter.setAttribute('aria-hidden', 'true');
        const lines = text.replace(/\n$/, '').split('\n').length;
        gutter.textContent = Array.from({length: lines}, function (_, index) { return index + 1; }).join('\n');
        wrapper.appendChild(gutter);
        const language = (code.className + ' ' + pre.className).match(/(?:language|lang)-([\w+-]+)/);
        const label = document.createElement('span');
        label.className = 'fw-code-label';
        label.textContent = code.dataset.language || (language ? language[1] : 'code');
        wrapper.appendChild(label);
        const copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'fw-code-copy';
        copy.textContent = labels.copy;
        copy.setAttribute('aria-label', labels.copyCode);
        copy.addEventListener('click', async function () {
            try {
                await navigator.clipboard.writeText(text);
                copy.textContent = labels.copied;
            } catch (error) {
                copy.textContent = labels.selectCopy;
                const selection = window.getSelection();
                const range = document.createRange();
                range.selectNodeContents(code);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            setTimeout(function () { copy.textContent = labels.copy; }, 2000);
        });
        wrapper.appendChild(copy);
        // Keep the gutter aligned when a long block is scrolled vertically.
        pre.addEventListener('scroll', function () { gutter.scrollTop = pre.scrollTop; }, {passive: true});
    });
})();

/* Load local KaTeX presentation only for articles that already contain rendered math. */
(function () {
    if (!document.querySelector('.fw-content .katex')) return;
    const source = document.currentScript;
    if (!source || !source.src) return;
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = new URL('../vendor/katex/katex.css', source.src).href;
    document.head.appendChild(stylesheet);
})();

/* Imported repository cards remain useful links when their Astro-only fetch script is absent. */
(function () {
    const labels = document.getElementById('fw-i18n').dataset;
    document.querySelectorAll('.fw-content a.card-github.fetch-waiting').forEach(function (card) {
        card.classList.remove('fetch-waiting');
        card.classList.add('fw-repo-static');
        const description = card.querySelector('.gc-description');
        if (description) description.textContent = labels.repository;
        const info = card.querySelector('.gc-infobar');
        if (info) info.remove();
    });
})();

/* Highlight plain Ghost code locally; never re-tokenize authored HTML or already rendered spans. */
(function () {
    const blocks = Array.from(document.querySelectorAll('.fw-code pre > code')).filter(function (code) { return !code.children.length; });
    if (!blocks.length) return;
    const source = document.currentScript;
    const script = document.createElement('script');
    script.src = new URL('../vendor/highlight/highlight.min.js', source.src).href;
    script.onload = function () {
        blocks.forEach(function (code) {
            const match = (code.className + ' ' + code.parentElement.className).match(/(?:language|lang)-([\w+-]+)/);
            const language = code.dataset.language || (match && match[1]);
            if (/^(text|plaintext|none)$/i.test(language || '')) return;
            if (language && !window.hljs.getLanguage(language)) return;
            const text = code.textContent;
            const result = language ? window.hljs.highlight(text, {language: language, ignoreIllegals: true}) : window.hljs.highlightAuto(text);
            // highlight.js escapes source text before adding its own token spans.
            code.innerHTML = result.value;
            code.classList.add('hljs');
        });
    };
    document.head.appendChild(script);
})();

/* Render ANSI SGR colors as safe text spans, including 256-color and RGB examples. */
(function () {
    const palette = ['#000000', '#cd3131', '#0dbc79', '#e5e510', '#2472c8', '#bc3fbc', '#11a8cd', '#e5e5e5', '#666666', '#f14c4c', '#23d18b', '#f5f543', '#3b8eea', '#d670d6', '#29b8db', '#ffffff'];
    // Map the standard terminal palette without interpreting escape sequences as markup.
    function color(index) {
        if (index < 16) return palette[index];
        if (index >= 232) return 'rgb(' + Array(3).fill(8 + (index - 232) * 10).join(',') + ')';
        const cube = index - 16;
        return 'rgb(' + [Math.floor(cube / 36), Math.floor(cube / 6) % 6, cube % 6].map(function (value) { return value ? 55 + value * 40 : 0; }).join(',') + ')';
    }
    document.querySelectorAll('.fw-code code.language-ansi').forEach(function (code) {
        const parts = code.textContent.split(/\x1b\[([\d;]*)m/g);
        let style = {};
        const fragment = document.createDocumentFragment();
        parts.forEach(function (part, index) {
            if (!(index % 2)) {
                const span = document.createElement('span');
                span.textContent = part;
                Object.assign(span.style, style);
                fragment.appendChild(span);
                return;
            }
            const values = part.split(';').map(Number);
            for (let i = 0; i < values.length; i++) {
                const value = values[i];
                if (!value) style = {};
                else if (value === 1) style.fontWeight = '700';
                else if (value === 2) style.opacity = '.5';
                else if (value === 3) style.fontStyle = 'italic';
                else if (value === 4) style.textDecoration = 'underline';
                else if (value === 22) { delete style.fontWeight; delete style.opacity; }
                else if (value === 23) delete style.fontStyle;
                else if (value === 24) delete style.textDecoration;
                else if (value === 39) delete style.color;
                else if (value === 49) delete style.backgroundColor;
                else if (value === 38 || value === 48) {
                    const property = value === 38 ? 'color' : 'backgroundColor';
                    const mode = values[++i];
                    if (mode === 5) style[property] = color(Math.min(255, Math.max(0, values[++i])));
                    else if (mode === 2) { style[property] = 'rgb(' + values.slice(i + 1, i + 4).map(function (v) { return Math.min(255, Math.max(0, v)); }).join(',') + ')'; i += 3; }
                } else if (value >= 30 && value <= 37) style.color = color(value - 30);
                else if (value >= 90 && value <= 97) style.color = color(value - 90 + 8);
                else if (value >= 40 && value <= 47) style.backgroundColor = color(value - 40);
                else if (value >= 100 && value <= 107) style.backgroundColor = color(value - 100 + 8);
            }
        });
        code.replaceChildren(fragment);
    });
})();
